import { render, staticRenderFns } from "./query-view.vue?vue&type=template&id=2212c102&scoped=true&lang=pug"
import script from "./query-view.vue?vue&type=script&lang=js"
export * from "./query-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2212c102",
  null
  
)

export default component.exports